import { render, staticRenderFns } from "./DAHistoryHeader.vue?vue&type=template&id=8482bbe0&scoped=true"
import script from "./DAHistoryHeader.vue?vue&type=script&lang=js"
export * from "./DAHistoryHeader.vue?vue&type=script&lang=js"
import style0 from "./DAHistoryHeader.vue?vue&type=style&index=0&id=8482bbe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8482bbe0",
  null
  
)

export default component.exports